import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Alert, Row, Col, Label, Modal, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { toast } from 'react-toastify'
import MediaQuery from 'react-responsive'
import { DataTable, MainLoader } from '../../../../components'
import { layout } from '../../../../common/constants'
import { formatHelper } from '../../../../common/helpers'
import Swal from 'sweetalert2'

import { getCustomers } from '../../../../store/customer/actions'
import { getStores } from '../../../../store/store/actions'
import { getOffers } from '../../../../store/offer/actions'
import { getProducts } from '../../../../store/product/actions'
import { getServices } from '../../../../store/service/actions'
import { createQuotation, resetCreateQuotation } from '../../../../store/quotation/actions'

import * as columns from './_columns'
import { FormItem, FormQuotation } from './Forms'

import { selectStoresForSelectQuotation } from '../../../../store/store/selector'
import { selectCustomerForSelect } from '../../../../store/customer/selector'

class QuotationAdd extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedProducts: [],
            selectedServices: [],
            selectedOffers: [],
            modalOpen: false,
            itemType: '',
            counter: 0,
        }

        this.onSubmitQuotation = this.onSubmitQuotation.bind(this);
        this.onSubmitQuotationItem = this.onSubmitQuotationItem.bind(this);

        this.toggleModal = this.toggleModal.bind(this);
        this.optionsFormatterColumnProducts = this.optionsFormatterColumnProducts.bind(this);
        this.optionsFormatterColumnServices = this.optionsFormatterColumnServices.bind(this);
        this.optionsFormatterColumnOffers = this.optionsFormatterColumnOffers.bind(this);
        this.changeFormatValues = this.changeFormatValues.bind(this)
    }

    componentDidMount() {
        //ITEMS
        this.props.getProducts({ reset: true })
        this.props.getServices({ reset: true })
        this.props.getOffers({ reset: true, show_expired_flag: 0 })

        //DROPDOWNS
        this.props.getCustomers({ reset: true })
        this.props.getStores({ reset: true })

    }

    componentWillUnmount() {
        this.props.resetCreateQuotation();
    }

    componentDidUpdate(prevProps) {
        this.checkQuotationCreationSuccess(prevProps)
        /*if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
            this.setState({ selectedStore: this.props.stores[0] })
        }*/
    }

    checkQuotationCreationSuccess(prevProps) {
        if (prevProps.quotation == null && this.props.quotation != null) {
            this.onSuccess(this.props.quotation)
        }
    }

    changeFormatValues(values) {
        values.products = formatHelper.cloneObject(this.state.selectedProducts)
        values.services = formatHelper.cloneObject(this.state.selectedServices)
        values.offers = formatHelper.cloneObject(this.state.selectedOffers)
        let customerId = values.customer
        values.customer = { id: customerId }
        if (values.discount) values.discount = values.discount / 100

        if (values.products || values.services || values.offers) {
            values.offers.forEach(offer => {
                if (offer.unit_discount && offer.type_unit_discount == "true") offer.unit_discount /= 100;
                offer.total_price = offer.before_price;
            });

            values.products.forEach(product => {

                if (product.unit_discount && product.type_unit_discount == "true") product.unit_discount /= 100;
                product.price = product.before_price;
            });

            values.services.forEach(service => {
                if (service.unit_discount && service.type_unit_discount == "true") service.unit_discount /= 100;
                service.price = service.before_price;
            });
        }
        return values
    }

    onSubmitQuotation(values) {
        let sendValues = formatHelper.cloneObject(values);
        sendValues = this.changeFormatValues(sendValues)
        this.props.createQuotation(sendValues);
    }

    onSubmitQuotationItem(values, activeItem) {
        //TODO:Añadir aca un identificador unico (GUID) para cada item de la tabla
        var { selectedProducts, selectedServices, selectedOffers, itemType, counter, } = this.state;
        if (itemType == 'Productos') {
            var products = selectedProducts
            values.name = activeItem.name
            values.oid = counter
            counter++
            products.push(values);
            this.setState({
                selectedProducts: products,
                modalOpen: false,
                counter: counter,
            })

        } else if (itemType == 'Servicios') {
            let services = selectedServices
            values.name = activeItem.name
            values.oid = counter
            counter++
            services.push(values);
            this.setState({
                selectedServices: services,
                modalOpen: false,
                counter: counter,
            })
        } else if (itemType == 'Ofertas') {
            let offers = selectedOffers
            values.name = activeItem.name
            values.oid = counter
            counter++
            offers.push(values);
            this.setState({
                selectedOffers: offers,
                modalOpen: false,
                counter: counter,
            })
        }
    }

    toggleModal(type) {

        this.setState({
            itemType: type,
            modalOpen: !this.state.modalOpen
        })
    }

    onSuccess(quotation) {
        let toastMessage = `Cotización Creada Satisfactoriamente.`
        this.performShowCotCode(quotation.code, toastMessage)
    }

    performShowCotCode(code, toastMessage) {
        Swal({
            title: `${code}`,
            text: `Este es el código de la cotización`,
            type: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK',
        }).then(() => {
            toast.success(toastMessage)
            this.props.history.push('/administration/quotations')
        })
    }

    performDeleteItem(id, type) {
        let list = type == 'Productos' ? this.state.selectedProducts : (type == 'Servicios' ? this.state.selectedServices : this.state.selectedOffers);
        list = list.filter(function (obj) {
            return obj.oid !== id //TODO: cambiar esto por un idTable
        })
        if (type == 'Productos') { this.setState({ selectedProducts: list }) }
        else if (type == 'Servicios') { this.setState({ selectedServices: list }) }
        else if (type == 'Ofertas') { this.setState({ selectedOffers: list }) }
    }

    //TODO: cambiar en los formatterColumn el id por idTable
    optionsFormatterColumnProducts(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Productos')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }
    optionsFormatterColumnServices(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Servicios')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }
    optionsFormatterColumnOffers(cell, row) {
        return (
            <UncontrolledButtonDropdown>
                <DropdownToggle size="sm" color='primary'>
                    <i className="fa fa-bars"></i>
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem onClick={() => this.performDeleteItem(row.oid, 'Ofertas')} ><i className="fa fa-trash mr-1"></i> Eliminar</DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        )
    }

    renderDataTable(columns, data) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                loading={this.props.loading}
            />
        )
    }

    render() {
        const columnOptionProducts = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnProducts,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const columnOptionService = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnServices,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const columnOptionOffer = {
            dataField: '',
            text: '',
            isDummyField: true,
            formatter: this.optionsFormatterColumnOffers,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const { modalOpen, selectedProducts, selectedServices, selectedOffers, itemType } = this.state
        const { error, loadingOffers, loadingProducts, loadingServices, customers, loading, stores } = this.props
        const isLoading = (loadingOffers || loadingProducts || loadingServices)
        if (isLoading) {
            return <MainLoader />
        }
        return (
            <div className="animated">
                <Card>
                    <CardHeader>
                        Nueva Cotizacion
                    </CardHeader>


                    <CardBody>
                        {
                            error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )
                        }
                        {
                            customers && stores && (
                                <FormQuotation
                                    customers={this.props.customers}
                                    stores={this.props.stores}

                                    selectedOffers={this.state.selectedOffers}
                                    selectedServices={this.state.selectedServices}
                                    selectedProducts={this.state.selectedProducts}

                                    onSubmitQuotation={this.onSubmitQuotation}
                                    toggleModal={this.toggleModal}
                                    modalOpen={modalOpen}
                                    itemType={itemType}
                                    isLoading={loading}
                                ></FormQuotation>
                            )
                        }
                    </CardBody>

                </Card>
                {
                    < Card >
                        <CardHeader>
                            Items de Cotización
                        </CardHeader>
                        <CardBody>
                            {
                                selectedProducts.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Productos</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionProducts), selectedProducts)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                selectedServices.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Servicios</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionService), selectedServices)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                selectedOffers.length > 0 && (
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Label><b>Ofertas</b></Label>
                                                </Col>
                                            </Row>
                                            < Row >
                                                <Col>
                                                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsXS(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                                                        {this.renderDataTable(columns.columnsSM(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                                                        {this.renderDataTable(columns.columns(columnOptionOffer), selectedOffers)}
                                                    </MediaQuery>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )
                            }

                        </CardBody>
                    </Card>
                }
                {<Modal isOpen={modalOpen} >
                    {<FormItem
                        products={this.props.products}
                        services={this.props.services}
                        offers={this.props.offers}

                        itemType={this.state.itemType}
                        onSubmitQuotationItem={this.onSubmitQuotationItem}
                        toggleModal={this.toggleModal}
                    />}
                </Modal>}
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { quotation, error, loading } = state.quotation.newQuotation
    const { productList } = state.product
    const { serviceList } = state.service
    const { offersList } = state.offer

    return {
        quotation, error, loading,

        offers: offersList.offers,
        loadingOffers: offersList.loading,
        products: productList.products,
        loadingProducts: productList.loading,
        services: serviceList.services,
        loadingServices: serviceList.loading,

        customers: selectCustomerForSelect(state),
        stores: selectStoresForSelectQuotation(state),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCustomers,
        getStores,

        getProducts,
        getServices,
        getOffers,

        createQuotation, resetCreateQuotation,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationAdd)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationAdd/QuotationAdd.js